import { useState } from 'react';
import { getDeviceIdFromCookie } from 'utils/identifierCookies';

const useDeviceId = () => {
  // Read synchronously from the redirect-owned cookie so API calls and event
  // logging use the same device identifier from the very first render.
  const [deviceId] = useState<string>(() => getDeviceIdFromCookie());

  return deviceId;
};

export default useDeviceId;
